import { HttpService } from './HttpService';
import { IHttpService } from './IHttpService';
import { objectToUrl } from '../../helpers/ObjectHelper';
import { StorageService } from '../Storage/StorageService';

export abstract class HttpServiceBase {
    
    protected readonly baseUrlSislog = process.env.REACT_APP_BASE_URL_SISLOG || '';
    protected readonly baseUrlSislogApi = process.env.REACT_APP_BASE_URL_SISLOG_API || '';
    protected readonly baseUrlSislogV2Api = process.env.REACT_APP_BASE_URL_SISLOG_V2_API || '';
    protected readonly baseUrlFileRepositoryApi = process.env.REACT_APP_BASE_URL_FILEREPOSITORY_API || '';
    protected readonly baseUrlZerezesApi = process.env.REACT_APP_BASE_URL_ZEREZES_API || '';

    protected readonly http: IHttpService;

    constructor(http?: any | null) {
        const typeOfHttp = typeof http;
        if (typeOfHttp === 'object') {
            this.http = http
        } else if (typeOfHttp === 'function') {
            this.http = new http()
        } else {
            this.http = new HttpService(new StorageService())
        }
    }

    objectToUrl = (object: any) => objectToUrl(object);
}